import { render, staticRenderFns } from "./PartnersChart.vue?vue&type=template&id=0a18be79"
import script from "./PartnersChart.vue?vue&type=script&lang=js"
export * from "./PartnersChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/74a6e498-56df-5c0c-aa3e-2f5fe39d1378/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a18be79')) {
      api.createRecord('0a18be79', component.options)
    } else {
      api.reload('0a18be79', component.options)
    }
    module.hot.accept("./PartnersChart.vue?vue&type=template&id=0a18be79", function () {
      api.rerender('0a18be79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Dashboard/Stats/PartnersChart.vue"
export default component.exports